import React, { useEffect, useState } from 'react';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import {
  Checkbox,
  IconButton,
  styled,
  TableCell,
  TableRow,
  TextField
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { parsePrice } from '../../utils';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  btnColor,
  mainBlueColor,
  workingBudgetData,
  workingBudgetVendor
} from '../../GlobalState';
import { TypeRow, TypeVendorInfo } from '../../types/WorkingBudgetPage';
import _ from 'lodash';
import { Vender } from './Vender';
import { LAYER_LIST } from '../../const/WorkingBudgetPage';
import { getCostPriceBackgroundColor } from './CostPriceBackgroudColor';

const StyledTableCell = withStyles(theme => ({
  root: {
    backgroundColor: '#FFF'
  },
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      // backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

const StyledIconCell = withStyles(theme => ({
  root: {
    padding: 0
  }
}))(TableCell);

// カラムの横幅
const colWidth = {
  icon: 50, // 階層アイコン
  itemName: 225, // 項目
  details: 225, // 仕様・詳細
  budgetQuantity: 100, // 数量
  budgetUnit: 75, // 単位
  estimatedPrice: 130, // 見積 単価
  estimatedAmount: 130, // 見積 金額
  costPrice: 130, // 原価 単価
  costAmount: 130 // 原価 金額
};

type TProps = {
  isDetailShow: boolean;
  data: TypeRow;
  indent: number;
  open: boolean;
  setOpen: any;
  layer_key: string;
  bankName: string;
  workingBudgetId: number;
};

export const TableItemRow: React.FC<TProps> = (props: TProps) => {
  const {
    isDetailShow,
    data,
    indent,
    open,
    setOpen,
    layer_key,
    bankName,
    workingBudgetId
  } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const classes = useStyles({ mainColor: mainColor });
  const [vendor, setVendor] = useRecoilState(workingBudgetVendor);
  const [costPriceBackgroundColor, setCostPriceBackgroundColor] = useState('');

  useEffect(() => {
    const costPriceBackgroundColor = getCostPriceBackgroundColor(
      data.vendor_order_price,
      data.cost_price
    );
    setCostPriceBackgroundColor(costPriceBackgroundColor);
  }, [data.vendor_order_price, data.cost_price]);

  return (
    <StyledTableRow
      className='click_table_row'
      style={{ height: 70 }}
      // title="編集"
    >
      <StyledIconCell
        className={classes.table1}
        style={{
          position: 'sticky',
          width: colWidth.icon,
          left: 0,
          backgroundColor: '#ffffff',
          zIndex: 1,
          border: '0.5px #CCCCCC solid'
        }}
      >
        {data.has_under_layer_flg ? (
          <IconButton
            aria-label='expand row'
            size='small'
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        ) : (
          <></>
        )}
      </StyledIconCell>

      <Tooltip data={data} isDetailShow={isDetailShow}>
        <StyledTableCell
          className={classes.table1}
          align='left'
          style={{
            backgroundColor: '#ffffff',
            position: 'sticky',
            width: colWidth.itemName,
            left: 50,
            zIndex: 1,
            border: '0.5px #CCCCCC solid'
          }}
        >
          <div style={{ marginLeft: indent - 1 === 1 ? 3 : 15 * (indent - 1) }}>
            {layer_key != LAYER_LIST.FIRST && (
              <div style={{ color: '#A4A4A5', fontSize: 12 }}>{bankName}</div>
            )}
            <div>{data.name}</div>
          </div>
        </StyledTableCell>
      </Tooltip>

      {isDetailShow ? (
        <>
          <StyledTableCell
            className={classes.tableText}
            align='left'
            style={{
              backgroundColor: '#ffffff',
              position: 'sticky',
              width: colWidth.details,
              left: 275,
              zIndex: 1,
              border: '0.5px #CCCCCC solid'
            }}
          >
            {data.detail}
          </StyledTableCell>
        </>
      ) : (
        <></>
      )}

      <Tooltip data={data} isDetailShow={isDetailShow}>
        <StyledTableCell
          className={classes.tableNum}
          align='right'
          style={{
            backgroundColor: '#ffffff',
            position: 'sticky',
            width: colWidth.budgetQuantity,
            left: 500 - (isDetailShow ? 0 : 225),
            zIndex: 1,
            border: '0.5px #CCCCCC solid'
          }}
        >
          {data.cost_quantity}
        </StyledTableCell>
      </Tooltip>

      <Tooltip data={data} isDetailShow={isDetailShow}>
        <StyledTableCell
          className={classes.tableText}
          align='left'
          style={{
            backgroundColor: '#ffffff',
            position: 'sticky',
            width: colWidth.budgetUnit,
            left: 600 - (isDetailShow ? 0 : 225),
            zIndex: 1,
            border: '0.5px #CCCCCC solid'
          }}
        >
          {data.cost_unit_name}
        </StyledTableCell>
      </Tooltip>

      {isDetailShow ? (
        <>
          <StyledTableCell
            className={classes.tableNum}
            align='right'
            style={{
              backgroundColor: '#ffffff',
              position: 'sticky',
              width: colWidth.estimatedPrice,
              left: 675,
              zIndex: 1,
              border: '0.5px #CCCCCC solid'
            }}
          >
            {`${data.selling_unit_price}円`}
          </StyledTableCell>
          <StyledTableCell
            className={classes.tableNum}
            align='right'
            style={{
              backgroundColor: '#ffffff',
              position: 'sticky',
              width: colWidth.estimatedAmount,
              left: 805,
              zIndex: 1,
              border: '0.5px #CCCCCC solid'
            }}
          >
            {parsePrice(data.selling_price)}
            <br />
            <span style={{ fontSize: 14 }}>{`(${
              data.quantity + (data.unit_name ? data.unit_name : '')
            })`}</span>
          </StyledTableCell>
        </>
      ) : (
        <></>
      )}

      <Tooltip data={data} isDetailShow={isDetailShow}>
        <StyledTableCell
          className={classes.tableNum}
          align='right'
          style={{
            backgroundColor: '#ffffff',
            position: 'sticky',
            width: colWidth.costPrice,
            left: 935 - (isDetailShow ? 0 : 485),
            zIndex: 1,
            border: '0.5px #CCCCCC solid'
          }}
        >
          {`${data.cost_unit_price}円`}
        </StyledTableCell>
      </Tooltip>

      <Tooltip data={data} isDetailShow={isDetailShow}>
        <StyledTableCell
          className={classes.tableNum}
          align='right'
          style={{
            backgroundColor: costPriceBackgroundColor,
            position: 'sticky',
            width: colWidth.costAmount,
            left: 1065 - (isDetailShow ? 0 : 485),
            zIndex: 1,
            border: '0.5px #CCCCCC solid'
          }}
        >
          {parsePrice(data.cost_price)}
        </StyledTableCell>
      </Tooltip>

      {vendor &&
        vendor.length > 0 &&
        vendor.map((v: TypeVendorInfo) => (
          <Vender
            data={data}
            vender={v}
            layer_key={layer_key}
            workingBudgetId={workingBudgetId}
          />
        ))}
    </StyledTableRow>
  );
};

type TTooltipProps = {
  data: TypeRow;
  isDetailShow: boolean;
  children: any;
};

const Tooltip: React.FC<TTooltipProps> = (props: TTooltipProps) => {
  const { data, isDetailShow, children } = props;
  return (
    <>
      {!isDetailShow ? (
        <CustomTooltip
          title={
            <>
              <div style={{ fontSize: 15, fontWeight: 'bold' }}>仕様・詳細</div>
              <div>{data.detail}</div>

              <div style={{ fontSize: 15, fontWeight: 'bold' }}>見積</div>
              <div>単価 : {parsePrice(data.selling_unit_price)}</div>
              <div>金額 : {parsePrice(data.selling_price)}</div>
            </>
          }
          placement='right'
        >
          {children}
        </CustomTooltip>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    table1: {
      padding: 0
    },
    tableText: {
      paddingLeft: 5
    },
    tableNum: {
      paddingRight: 5
    },
    tableInput: {
      padding: 8
    }
  })
);
